export const DEFAULT_PAGE_INDEX = 0
export const DEFAULT_PAGE_SIZE = 10

export const VALID_ITEMS_PER_PAGE_PARAM = ['5', '10', '20']

export const getPageSizeOptions = (t: any): {label: string; value: number}[] =>
  VALID_ITEMS_PER_PAGE_PARAM.map(pageSizeString => ({
    label: t(`pagination.results-${pageSizeString}.label`, {ns: 'ui'}),
    value: parseInt(pageSizeString, 10),
  }))

export const SHIPMENT_DETAILS_SORTING_OPTIONS: {field: string; orderBy?: string; id: number}[] = [
  {field: 'shipmentStartDate', orderBy: 'ASC', id: 1},
  {field: 'shipmentStartDate', orderBy: 'DESC', id: 2},
  {field: 'shipmentEndDate', orderBy: 'ASC', id: 3},
  {field: 'shipmentEndDate', orderBy: 'DESC', id: 4},
  {field: 'lastEventDate', orderBy: 'ASC', id: 5},
  {field: 'lastEventDate', orderBy: 'DESC', id: 6},
  {field: 'status', orderBy: 'ASC', id: 7},
  {field: 'status', orderBy: 'DESC', id: 8},
]
